<template>
  <a-card :bordered="false" title="价格规则">
    <div class="content-main">
      <ul>
        <li>本系统价格</li>
        <li>成人销售价</li>
        <li>儿童销售价</li>
        <li>成人同行价</li>
        <li>儿童同行价</li>
        <li>成人佣金</li>
        <li>儿童佣金</li>
        <li>成人市场价</li>
        <li>儿童市场价</li>
        <li>成人采购价</li>
        <li>儿童采购价</li>
      </ul>
      <ul class="right-box">
        <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一起行系统价格</li>
        <li>= &nbsp;&nbsp;&nbsp;成人价格</li>
        <li>= &nbsp;&nbsp;&nbsp;儿童价格</li>
        <li>= &nbsp;&nbsp;（成人价格-成人返佣）*
          <a-input-number placeholder="请输入" v-model="upPeerPrice" :min="1" :max="100" :precision="0"/>
          %
        </li>
        <li>= &nbsp;&nbsp;（儿童价格-成人返佣）*
          <a-input-number placeholder="请输入" v-model="upPeerChildPrice" :min="1" :max="100" :precision="0"/>
          %
        </li>
        <li>= &nbsp;&nbsp;&nbsp;成人返佣*
          <a-input-number placeholder="请输入" v-model="upCommissionPrice" :min="1" :max="100" :precision="0"/>
          %
        </li>
        <li>= &nbsp;&nbsp;&nbsp;儿童返佣*
          <a-input-number placeholder="请输入" v-model="upCommissionChildPrice" :min="1" :max="100" :precision="0"/>
          %
        </li>
        <li>= &nbsp;&nbsp;&nbsp;成人销售价</li>
        <li>= &nbsp;&nbsp;&nbsp;儿童销售价</li>
        <li>= &nbsp;&nbsp;&nbsp;成人同行价</li>
        <li>= &nbsp;&nbsp;&nbsp;儿童同行价</li>
      </ul>
    </div>
    <div style="padding-left:90px;">
      <a-button type="primary" @click="handleSubmit">保存</a-button>
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'SynchronizationRules',
  data() {
    return {
      upPeerChildPrice: '',
      upPeerPrice: '',
      upCommissionPrice: '',
      upCommissionChildPrice: '',
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SynchronousProducts', title: '同步产品' },
      { name: 'DirectOrdersList', title: '订单直连' },
      { name: 'TogetherAccount', title: '关联账号' }
    ])
    this.getDetail()
  },
  methods: {
    getDetail() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('travel/sync-rule', params)
        .then(res => {
          this.upCommissionChildPrice = res.upCommissionChildPrice
          this.upCommissionPrice = res.upCommissionPrice
          this.upPeerChildPrice = res.upPeerChildPrice
          this.upPeerPrice = res.upPeerPrice
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleSubmit() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        upPeerChildPrice: this.upPeerChildPrice,
        upPeerPrice: this.upPeerPrice,
        upCommissionPrice: this.upCommissionPrice,
        upCommissionChildPrice: this.upCommissionChildPrice
      }
      this.getHttpServices().getServerApiService().post('travel/sync-rule/add-edit', params)
        .then(res => {
          this.$message.success('成功保存')
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>

<style scoped lang="less">
.tips {
  font-size: 14px;
  padding-left: 15px;
}

ul, li {
  list-style: none;
  padding: 0;
}

.content-main {
  display: flex;

  ul {
    &:first-child {
      background: #E9E9E9;
    }

    li {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;

      &:first-child {
        font-weight: bold;
      }
    }
  }
}
</style>